import { alpha, type SxProps, type Theme } from '@mui/material/styles';

/**
 * The outline every "Hinzufuegen" wears. Where a label fits that is a plain
 * `<Button variant="outlined">`; where only the icon does, an IconButton takes
 * this, because MUI 9's IconButton has no `variant` prop and so cannot get the
 * outline from a theme default.
 *
 * Copies what the outlined Button draws: the border at half opacity, full on
 * hover, and the theme's radius rather than an IconButton's circle.
 */
export const addOutlineSx: SxProps<Theme> = (theme) => ({
    color: 'primary.main',
    border: `1px solid ${alpha(theme.palette.primary.main, 0.5)}`,
    borderRadius: 1,
    '&:hover': {
        borderColor: 'primary.main'
    },
    '&.Mui-disabled': {
        borderColor: theme.palette.action.disabledBackground
    }
});
